import Site from './Site.mjs'
import Brand from './Brand.mjs'
import Rates from './Rates.mjs'
import Change from './Change.mjs'
import ScreenType from './ScreenType.mjs'
import Template from './Template.mjs'
import Device from './Device.mjs'
import Messages from './Messages.mjs'

export default class ParseModel {
  constructor (Parse, appId, serverUrl) {
    this.Parse = Parse
    this.Parse.initialize(appId)
    this.Parse.serverURL = serverUrl

    this.site = new Site(this.Parse)
    this.brand = new Brand(this.Parse)
    this.rates = new Rates(this.Parse)
    this.change = new Change(this.Parse)
    this.screenType = new ScreenType(this.Parse)
    this.template = new Template(this.Parse)
    this.device = new Device(this.Parse)
    this.messages = new Messages(this.Parse)
  }

  query (className) {
    var Class = this.Parse.Object.extend(className)
    return new this.Parse.Query(Class)
  }

  find (query, callback) {
    query.find({
      success: function (results) {
        console.log('results', results)
        callback(results)
      },
      error: function (error) {
        console.log('VueParse find error', error)
      }
    })
  }

  first (query, callback) {
    query.first({
      success: function (object) {
        console.log('result', object)
        callback(object)
      },
      error: function (error) {
        console.log('VueParse find error', error)
      }
    })
  }
}




//////////////////
// WEBPACK FOOTER
// ./parse-model/ParseModel.mjs
// module id = d9pt
// module chunks = 0